import React, { useState, useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const A = '#00D4AA';

function tokenUitUrl(params) {
  const q = params.get('token');
  if (q) return q;
  const h = window.location.hash || '';
  const m = h.match(/[?&]token=([^&]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}

export default function WachtwoordInstellen() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { wachtwoordInstellen } = useAuth();
  const token = useMemo(() => tokenUitUrl(params), [params]);
  const [ww, setWw] = useState('');
  const [ww2, setWw2] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (ww !== ww2) { setError('De wachtwoorden komen niet overeen.'); return; }
    setBusy(true);
    try {
      await wachtwoordInstellen(token, ww);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Instellen mislukt. De link is mogelijk verlopen.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: '#0a0e1a' }}>
      <div style={{ width: '100%', maxWidth: 380, background: '#111827', borderRadius: 16, padding: 28, boxShadow: '0 10px 40px rgba(0,0,0,0.4)' }}>
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#e2e8f0' }}>Wachtwoord instellen</div>
        </div>
        {!token ? (
          <p style={{ color: '#fecaca', fontSize: 14, textAlign: 'center' }}>Geen geldige link. Open de link uit je uitnodigingsmail.</p>
        ) : (
          <form onSubmit={submit}>
            <p style={{ color: '#94a3b8', fontSize: 12, lineHeight: 1.5, marginTop: 0 }}>
              Minimaal 10 tekens, met een hoofdletter, kleine letter, cijfer en speciaal teken.
            </p>
            <label style={{ display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 6 }}>Nieuw wachtwoord</label>
            <input type="password" value={ww} onChange={(e) => setWw(e.target.value)} required autoComplete="new-password"
              style={{ width: '100%', padding: '12px 14px', marginBottom: 16, borderRadius: 10, border: '1px solid #1f2937', background: '#0a0e1a', color: '#e2e8f0' }} />
            <label style={{ display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 6 }}>Herhaal wachtwoord</label>
            <input type="password" value={ww2} onChange={(e) => setWw2(e.target.value)} required autoComplete="new-password"
              style={{ width: '100%', padding: '12px 14px', marginBottom: 20, borderRadius: 10, border: '1px solid #1f2937', background: '#0a0e1a', color: '#e2e8f0' }} />
            {error && <div style={{ background: '#7f1d1d', color: '#fecaca', padding: '10px 12px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}
            <button type="submit" disabled={busy}
              style={{ width: '100%', padding: '13px', borderRadius: 10, border: 'none', background: busy ? '#0f766e' : A, color: '#0a0e1a', fontWeight: 700, fontSize: 15 }}>
              {busy ? 'Bezig…' : 'Wachtwoord instellen'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
